/* eslint-disable jsx-quotes */
import React from 'react';

import ItemOptionQuestion from './components/ItemOptionQuestion';
import Loader from '../loader-component/loader';

import './styles.css';

class AddQuestionPresentation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            onCancel,
            title,
            handleInputText,
            handleItemsOptionQuestion,
            options,
            checkedOptionCorrect,
            titleOption,
            handleAddQuestion,
            handleRemoveItemsOptionQuestion,
            handleSelectCorrectOptionQuestion,
            hasOption,
            hasNewQuestion,
            loading,
            optionsValid,
            optionsValidToAddOptions,
            editMode,
            editTitleOption,
            checkedCorrectOption,
            enableEditMode,
            disableEditMode,
            saveOptionEditMode,
        } = this.props;

        return (
            <section className="container-add-question">
                <p className="title-modal">Adicionar questão</p>
                <form className="form-add-question">
                    <span className="form-add-question-content">
                        <span className="field">
                            <label htmlFor="title">Título</label>
                            <textarea
                                id="title"
                                onChange={({ target }) =>
                                    handleInputText(target)
                                }
                                name="title"
                                value={title}
                            />
                        </span>
                        {options && options.length > 0 && (
                            <React.Fragment>
                                <p
                                    style={{ textAlign: 'center' }}
                                    className="label-title-option"
                                >
                                    Opções
                                </p>
                                {options.map((option, index) => (
                                    <ItemOptionQuestion
                                        key={index}
                                        option={option}
                                        handleSelectCorrectOptionQuestion={
                                            handleSelectCorrectOptionQuestion
                                        }
                                        handleRemoveItemsOptionQuestion={
                                            handleRemoveItemsOptionQuestion
                                        }
                                        enableEditMode={enableEditMode}
                                        editMode={editMode}
                                    />
                                ))}
                            </React.Fragment>
                        )}
                        <span className="add-item">
                            {!editMode ? (
                                <React.Fragment>
                                    <span className="field">
                                        <label htmlFor="titleOption">
                                            Título da opção
                                        </label>
                                        <textarea
                                            id="titleOption"
                                            onChange={({ target }) =>
                                                handleInputText(target)
                                            }
                                            type="text"
                                            name="titleOption"
                                            value={titleOption}
                                        />
                                        {hasOption && (
                                            <p className="error-text">
                                                Já existe essa opção
                                            </p>
                                        )}
                                    </span>
                                    <span className="checked">
                                        <label htmlFor="checkedOptionCorrect">
                                            Opção correta?
                                        </label>
                                        <input
                                            id="checkedOptionCorrect"
                                            onChange={({ target }) =>
                                                handleInputText({
                                                    name:
                                                        'checkedOptionCorrect',
                                                    value: target.checked,
                                                })
                                            }
                                            type="checkbox"
                                            name="checkedOptionCorrect"
                                            checked={checkedOptionCorrect}
                                        />
                                    </span>
                                    <button
                                        onClick={() =>
                                            handleItemsOptionQuestion({
                                                title: titleOption,
                                                correct: checkedOptionCorrect,
                                                enabled: true,
                                            })
                                        }
                                        className={
                                            titleOption === '' ||
                                            options.length >= 10 ||
                                            hasOption
                                                ? 'disabled-button'
                                                : ''
                                        }
                                        disabled={
                                            titleOption === '' ||
                                            options.length >= 10 ||
                                            hasOption
                                                ? true
                                                : false
                                        }
                                        type="button"
                                    >
                                        Adicionar Opção
                                    </button>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <p className="label-title-option">
                                        Atualizar opção
                                    </p>
                                    <span className="field">
                                        <label htmlFor="editTitleOption">
                                            Título da opção
                                        </label>
                                        <textarea
                                            id="editTitleOption"
                                            onChange={({ target }) =>
                                                handleInputText(target)
                                            }
                                            type="text"
                                            name="editTitleOption"
                                            value={editTitleOption}
                                        />
                                        {hasOption && (
                                            <p className="error-text">
                                                Já existe essa opção
                                            </p>
                                        )}
                                    </span>
                                    <span className="checked">
                                        <label htmlFor="checkedCorrectOption">
                                            Opção correta?
                                        </label>
                                        <input
                                            id="checkedCorrectOption"
                                            onChange={({ target }) =>
                                                handleInputText({
                                                    name:
                                                        'checkedCorrectOption',
                                                    value: target.checked,
                                                })
                                            }
                                            type="checkbox"
                                            name="checkedCorrectOption"
                                            checked={checkedCorrectOption}
                                        />
                                    </span>
                                    <button
                                        onClick={() =>
                                            saveOptionEditMode({
                                                title: editTitleOption,
                                                correct: checkedCorrectOption,
                                            })
                                        }
                                        className={
                                            editTitleOption === '' ||
                                            !optionsValidToAddOptions ||
                                            hasOption
                                                ? 'disabled-button'
                                                : ''
                                        }
                                        disabled={
                                            editTitleOption === '' ||
                                            !optionsValidToAddOptions ||
                                            hasOption
                                                ? true
                                                : false
                                        }
                                        type="button"
                                    >
                                        Atualizar item
                                    </button>
                                </React.Fragment>
                            )}
                            {editMode && (
                                <button
                                    className="cancel-btn"
                                    onClick={disableEditMode}
                                    type="button"
                                >
                                    Cancelar
                                </button>
                            )}
                        </span>
                    </span>
                    <span className="checked self-left">
                        <label htmlFor="hasNewQuestion">
                            Criar nova questão
                        </label>
                        <input
                            id="hasNewQuestion"
                            onChange={({ target }) =>
                                handleInputText({
                                    name: 'hasNewQuestion',
                                    value: target.checked,
                                })
                            }
                            type="checkbox"
                            name="hasNewQuestion"
                            checked={hasNewQuestion}
                        />
                    </span>
                </form>
                <span className="line-buttons-add-question">
                    <button className="button" type="button" onClick={onCancel}>
                        Cancelar
                    </button>
                    <button
                        className={
                            title === ''
                                ? 'add-question-btn disabled-button'
                                : 'add-question-btn'
                        }
                        disabled={title === '' ? true : false}
                        type="button"
                        onClick={() => {
                            handleAddQuestion({
                                question: title,
                                options: options || [],
                                hasNewQuestion: hasNewQuestion,
                            });
                        }}
                    >
                        Salvar
                    </button>
                </span>
                {loading > 0 && (
                    <Loader
                        show={loading > 0 ? true : false}
                        message={'Carregando, por favor aguarde...'}
                    />
                )}
            </section>
        );
    }
}

export default AddQuestionPresentation;



// WEBPACK FOOTER //
// ./src/components/add-question/add-question-presentation.js